import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const MdxP = props => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsx("p", Object.assign({}, props))
  });
};